import React from 'react';
import PageTitle from '../../Shared/PageTitle/PageTitle';

const Checkout = () => {
    return (
        <div>
            <PageTitle title="Checkout"></PageTitle>
            <h2>Please CheckOut Your Booking</h2>
        </div>
    );
};

export default Checkout;